import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import MainLoader from "../components/sub/MainLoader";
import { useGlobalSettings } from "../context/GlobalSettingsContext";

function OpenRoute() {
  const authState = useSelector((state) => state.authState.value);
  const { defaultLandingPage } = useGlobalSettings();
  if (authState === "login") {
    return <Navigate to={defaultLandingPage || "/my-plans"} replace />;
  } else if (authState === "logout") {
    return <Outlet />;
  }
  return <MainLoader />;
}

export default OpenRoute;
